import ka from '../locales/ka.json';

const locales = { ka };
const lang = process.env.VUE_APP_AUTO_TRANSLATE_LANG;
const isNational19 = process.env.VUE_APP_NATIONAL_ID === '19';
const messages = (lang && isNational19 && locales[lang]) || {};

export default {
  install(app) {
    // $t(key) → returns custom translation if available, otherwise returns key as-is
    app.config.globalProperties.$t = (key) => messages[key] || key;
  }
};
